import { PersonFields, JurisdictionFields, ArrestFields, CustodyFields, CaseFields, DocumentFields, IntakeSubmitArea } from './IntakeSections';
import { useIntakeForm } from '../../hooks/useIntakeForm';
import options from '../../content/intakeOptions.json';

export const IntakeForm = ({ onSaved }) => {
  const { values, busy, error, form, update, field, choice, submit } = useIntakeForm(onSaved);
  const region = options.regions.find(item => item.value === values.caseRegion);
  return <form ref={form} className="intake-form ph-no-capture ph-mask" data-testid="intake-form" onSubmit={submit} noValidate aria-busy={busy}>
    <PersonFields values={values} field={field} choice={choice} />
    <JurisdictionFields field={field} />
    <CustodyFields values={values} field={field} choice={choice} region={region} />
    <ArrestFields field={field} region={region} />
    <CaseFields values={values} field={field} update={update} busy={busy} />
    <DocumentFields values={values} field={field} update={update} busy={busy} />
    <div className="intake-honeypot" aria-hidden="true"><label htmlFor="intake-company" data-testid="intake-company-label">Company</label><input id="intake-company" name="company" tabIndex={-1} autoComplete="off" value={values.company} onChange={event => update('company', event.target.value)} data-testid="intake-company-input" /></div>
    <IntakeSubmitArea busy={busy} error={error} />
  </form>;
};